import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Styled Components
import {
  Container,
  Label,
  DataContainer,
  RowContainer,
  Title,
  DataText,
  Explore,
  RemoveButton,
  ContainerButton,
} from './styles';

// Actions
import { deselectedRowModalTable } from '../../../state/actions/ui/selectRowTableModal';

// Components
import { SpecialTag } from '../SpecialTag';

// Types
import { SelectionProps } from './types';
import { variant } from '../SpecialTag/types';

export const SelectionOT = ({
  label,
  data,
  openModal,
  namingPersistForm,
  type,
  onChange,
  onRemove,
  ...props
}: SelectionProps): JSX.Element => {
  const { t } = useTranslation(['common', 'forms']);
  const dispatch = useDispatch();
  const deselectedModalAction = useCallback(() => {
    dispatch(deselectedRowModalTable(namingPersistForm));
    onRemove?.();
  }, [namingPersistForm, dispatch, onRemove]);

  // Sync Redux data with react-hook-form when selection changes
  useEffect(() => {
    if (onChange) {
      if (data?.isShowedData && data?.data) {
        // There is a valid selection
        onChange(data);
      } else {
        // No selection or data was cleared
        onChange(undefined);
      }
    }
  }, [data?.isShowedData, data?.data?.roid, onChange]);

  return (
    <Container {...props}>
      <Label component="label" variant="regular" size="S">
        {label}
      </Label>
      <DataContainer>
        {data?.isShowedData ? (
          <>
            <ContainerButton>
              <RemoveButton
                variant="delete"
                type="button"
                onClick={deselectedModalAction}
              />
            </ContainerButton>
            <RowContainer>
              <Title variant="regular" size="S" colorText="garnet">
                {t('common:tables.headers.roid')}
              </Title>
              <DataText variant="regular" size="S">
                {Array.isArray(data.data?.roid)
                  ? data.data.roid.join('.')
                  : data.data?.roid}
              </DataText>
            </RowContainer>
            <RowContainer>
              <Title variant="regular" size="S" colorText="garnet">
                {t('common:tables.headers.capitol')}
              </Title>
              <DataText variant="regular" size="S">
                {data.data?.capitol}
              </DataText>
            </RowContainer>
            <RowContainer>
              <Title variant="regular" size="S" colorText="garnet">
                {t('common:tables.headers.subCapitol')}
              </Title>
              <DataText variant="regular" size="S">
                {data.data?.subCapitol}
              </DataText>
            </RowContainer>
            {data.data?.tag && (
              <RowContainer>
                <SpecialTag variant={variant.SurveillanceRoute} />
              </RowContainer>
            )}
          </>
        ) : (
          <RowContainer>
            <Explore
              onClick={openModal}
              variant="regular"
              size="S"
              colorText="garnet"
              component="a"
            >
              + {t('common:buttons.explore')} {type}...
            </Explore>
          </RowContainer>
        )}
      </DataContainer>
    </Container>
  );
};
